$(document).ready(function () {
  $(".image-with-text-slider").flickity({
    cellAlign: "left",
    contain: true,
    freeScroll: false,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: true,
    arrowShape: { 
    x0: 10,
    x1: 60, y1: 50,
    x2: 60, y2: 45,
    x3: 15
  }
  });
});
